import SVGIconWrapper from "./SVGIconWrapper"

const IconClock = (props) => (
    <SVGIconWrapper
        fill={props.fill ?? "#000000"}
        style={props.style}
        viewBox="0 0 1792 1792"
        iconClass={`icon--clock ${props.iconClass}`}
        wrapperClass={props.wrapperClass}
        onClick={props.onClick}
    >
        <path d="M1024 544v448q0 14-9 23t-23 9H672q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h224V544q0-14 9-23t23-9h64q14 0 23 9t9 23zm416 352q0-148-73-273t-198-198-273-73-273 73-198 198-73 273 73 273 198 198 273 73 273-73 198-198 73-273zm224 0q0 209-103 385.5T1281.5 1561 896 1664t-385.5-103T231 1281.5 128 896t103-385.5T510.5 231 896 128t385.5 103T1561 510.5 1664 896z" />
    </SVGIconWrapper>
)

export default IconClock